import { jsx as t } from "react/jsx-runtime";
import { Global as l } from "@emotion/react";
const o = () => /* @__PURE__ */ t(
  l,
  {
    styles: `
      @property --angle {
        syntax: "<angle>";
        inherits: true;
        initial-value: 0turn;
      }
    `
  }
);
export {
  o as GlobalStyles
};
//# sourceMappingURL=GlobalStyles.es.js.map
